import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { H, Wrapper } from '@farewill/ui'
import { GTR, FONT } from '@farewill/ui/tokens'

const StyledListHeader = styled(H)`
  font-size: ${FONT.SIZE.S};
`

const StyledListItem = styled.li`
  font-size: ${FONT.SIZE.S};
  position: relative;
  padding-left: ${GTR.S};
  margin-bottom: ${GTR.XS};

  &::before {
    content: '';
    position: absolute;
    background-color: currentColor;
    border-radius: 50%;
    width: 0.3em;
    height: 0.3em;
    left: 0;
    top: 0.7em;
  }
`

const NotesList = ({ notes }) => (
  <Wrapper margin={[0, 0, 'L']}>
    <StyledListHeader margin={['M', 0, 'XS']}>
      This could take less time if:
    </StyledListHeader>
    <ul>
      {notes.map((note) => (
        <StyledListItem key={note}>{note}</StyledListItem>
      ))}
    </ul>
  </Wrapper>
)

NotesList.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default NotesList
